import { toastError, toastSuccess } from "../../../utils/helpers/helper";
import { enrichContactsAPI, getEnrichContactsAPI } from "../../../utils/requests/enrich";
import { 
  ENRICH_LIST_REQUEST, 
  ENRICH_LIST_SUCCESS, 
  ENRICH_LIST_FAIL, 
  ENRICH_CONTACTS_REQUEST, 
  ENRICH_CONTACTS_SUCCESS, 
  ENRICH_CONTACTS_FAIL,
  ENRICH_ORGANIZATIONS_SUCCESS,
  ENRICH_ORGANIZATIONS_FAIL
} from "../../constants/enrichConstants";
import { getUserDetail } from "../users/users.actions";

export const getEnrichContacts = (query = "") => {
  return async (dispatch) => {
    dispatch({ type: ENRICH_LIST_REQUEST });
    return getEnrichContactsAPI(query)
      .then((response) => {
        dispatch({ type: ENRICH_LIST_SUCCESS, payload: response });
        
        // Extract unique organizations from the contacts
        // if (response && response.results) {
        //   const organizations = [...new Set(response.results
        //     .filter(contact => contact.organization)
        //     .map(contact => contact.organization))]
        //     .map(org => ({ value: org, label: org }));
            
        //   dispatch({ type: ENRICH_ORGANIZATIONS_SUCCESS, payload: organizations });
        // }
      })
      .catch((error) => {
        dispatch({
          type: ENRICH_LIST_FAIL,
          payload: error,
        });
        toastError("Unable to fetch Enrich Contacts");
      });
  };
};

export const enrichContacts = (enrichmentFilters, navigate) => {
  return async (dispatch) => {
    dispatch({ type: ENRICH_CONTACTS_REQUEST });
    return enrichContactsAPI({ filters: enrichmentFilters })
      .then((response) => {
        dispatch({ type: ENRICH_CONTACTS_SUCCESS, payload: response });
        toastSuccess("Contacts enriched successfully");
        navigate('/crm')
        dispatch(getUserDetail())
      })
      .catch((error) => {
        dispatch({
          type: ENRICH_CONTACTS_FAIL,
          payload: error,
        });
        toastError("Unable to enrich contacts");
      });
  };
}; 